import { capitalizeAllIfLower, formatDate } from '@btime/helpers'
import { compose, path, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { FlexCol } from '../../../components/structure/FlexGrid'
import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { UserAvatar } from '../../../components/presentation/Avatar'
import { useUserActionsList } from '../../../utils/actions/users/list'
import { useUserFastActionsList } from '../../../utils/actions/users/fastList'
import { useUserState } from './_load/UserLoader'
import DeletedTag from '../../../components/helpers/DeletedTag'
import DropdownLink from '../../../components/navigation/DropdownLink'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import LabelValue from '../../../packages/kiti/components/presentation/LabelValue'
import UserPresenterFromId from '../../../containers/users/UserPresenterFromId'
import { useIsMaster } from '@btime/react-session'

const ModalHeader = () => {
  const { t } = useTranslation('common')
  const user = useUserState()?.user
  const isMaster = useIsMaster()
  const options = useUserActionsList(user, null, { hide: ['seeDetails'] })

  const title = compose(capitalizeAllIfLower, prop('name'))(user)
  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), path(['contract', 'insertedAt']))(user)
  const updatedAt = compose(formatDate('DD/MM/YYYY HH:mm'), path(['contract', 'updatedAt']))(user)

  const fastActions = useUserFastActionsList(user)

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <UserAvatar user={user} size="normal" />
        <Col flex={1}>
          <Title size="h4" color="dark1" noMargin>
            {title}
          </Title>
          <SmallText color="dark3">
            {t('createdAt')} {createdAt}
          </SmallText>
        </Col>
        <Col flex={1}></Col>

        {!!user.contract.deleted && (
          <Col>
            <DeletedTag entity={user.contract} />
            {isMaster && (
              <>
                <LabelValue label={t('removedBy')}>
                  <UserPresenterFromId id={user.contract.deletedById} size="xsmall" hideIcon />
                </LabelValue>
                <SmallText color="dark3">
                  {t('updatedAt')} {updatedAt}
                </SmallText>
              </>
            )}
          </Col>
        )}
        <Col>
          <RefetchingIndicator />
        </Col>

        {!user.contract?.deleted && (
          <>
            {fastActions.map(action => (
              <>
                <FlexCol key={action.label}>
                  <IconText iconLeft={action.icon} color="dark3" bold {...action} noWrap />
                </FlexCol>
                <Separator vertical />
              </>
            ))}
            <Col>
              <DropdownLink
                fromRight
                options={options}
                actionContent={<Icon name="BsThreeDotsVertical" size={1.4} />}
                t={t}
              />
            </Col>
          </>
        )}
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
